export const PRODUCT_RECS_REQUEST = "PRODUCT_RECS_REQUEST";
export const PRODUCT_RECS_SUCCESS = "PRODUCT_RECS_SUCCESS";
export const PRODUCT_RECS_FAIL = "PRODUCT_RECS_FAIL";

export const CART_RECS_REQUEST = "CART_RECS_REQUEST";
export const CART_RECS_SUCCESS = "CART_RECS_SUCCESS";
export const CART_RECS_FAIL = "CART_RECS_FAIL";
